import React from "react";
import { Chip } from "@mui/material";

const StatusBadge = ({ label = "" }) => (
  <Chip
    label={label}
    size="small"
    className="tags"
    sx={{
      zIndex:10,
      "& .MuiChip-label": {
        px: 1.5,
      },
    }}
  />
);


export default StatusBadge;